import React, { useContext, useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoaderContext } from "../../../../App";
import FormService from "../../../../core/service/FormService";
import "./FormSectionModal.scss";

// Removes a section/sub-section through the form builder section API, with the form builder's two delete options
function DeleteFormSectionModal({ t, show, formId, section, isSubsection, onHide, onDeleted }) {
	const { setLoaderDisplay } = useContext(LoaderContext);

	const [deleteType, setDeleteType] = useState('');
	const [validated, setValidated] = useState(false);

	useEffect(() => {
		if (!show) return;
		setDeleteType('');
		setValidated(false);
	}, [show]);

	const onConfirm = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setValidated(true);
		if (!deleteType) return;

		setLoaderDisplay(true);
		FormService.deleteFormSection(formId, section.id, deleteType === 'DELETE').then(res => {
			if (res.status !== 200 && res.status !== 204) return;

			toast.success(t('SectionRemovedSuccessfully.label'), { position: toast.POSITION.TOP_RIGHT });
			// onDeleted may return a promise (the parent reloading the form); keep the loader until it settles
			return onDeleted?.(section.id);
		}).catch(err => { }).finally(() => setLoaderDisplay(false));
	};

	const renderOption = (value, label) => (
		<Form.Check id={`deleteFormSection-${value}`} type="radio" name="deleteFormSectionType"
			className="form-section-modal__check form-section-modal__radio" required
			label={label} value={value} checked={deleteType === value}
			onChange={(e) => setDeleteType(e.target.value)} />
	);

	return (
		<Modal show={show} onHide={onHide} centered className="form-section-modal">
			<Form noValidate validated={validated} onSubmit={onConfirm}>
				<Modal.Header closeButton className="form-section-modal__header">
					<Modal.Title className="form-section-modal__title">
						{t(isSubsection ? 'RemoveSubSection.label' : 'RemoveSection.label')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="form-section-modal__body">
					<p className="form-section-modal__label mb-3"><strong>{section?.title}</strong></p>
					{renderOption('DELETE', t('DeleteAllQuestionsInSection.label'))}
					{renderOption('MOVE', t('MoveAllQuestionsToAboveSection.label'))}
				</Modal.Body>
				<Modal.Footer className="form-section-modal__footer">
					<button type="button" className="form-section-modal__btn form-section-modal__btn--secondary" onClick={onHide}>
						{t('Cancel.label')}
					</button>
					<button type="submit" className="form-section-modal__btn form-section-modal__btn--danger" disabled={!deleteType}>
						{t('Delete.label')}
					</button>
				</Modal.Footer>
			</Form>
		</Modal>
	);
}

export default withTranslation()(DeleteFormSectionModal);
